// Add CONSTANTS here
export const INVEST_TABLE_FILTER_STORAGE_KEY = 'investments-spreadsheet-filters';
export const IS_FIRST_CONNECTION_STORAGE_KEY = 'is_first_connection';
export const ENABLED_COLUMNS_LOCAL_STORAGE_KEY = 'spreadsheet-columns-enabled';
export const FROZEN_COLUMNS_LOCAL_STORAGE_KEY = 'spreadsheet-columns-frozen';
export const SELECTED_SCENARII_LOCAL_STORAGE_KEY = 'analysis-selected-scenarii';
export const AG_GRID_INVESTMENT_FILTERS = 'ag_grid_investment_filters';
export const AG_GRID_DDR_FILTERS = 'ag_grid_ddr_filters';
export const AG_GRID_GROUP_FILTERS = 'ag_grid_group_filters';
export const AG_GRID_USER_FILTERS = 'ag_grid_user_filters';
export const AG_GRID_INVEST_TAG_FILTERS = 'ag_grid_invest_tag_filters';
export const AG_GRID_ACTION_TAG_FILTERS = 'ag_grid_action_tag_filters';
export const AG_GRID_WEIGHTING_FILTERS = 'ag_grid_weighting_filters';
export const DEFAULT_INVESTMENT_FILTERS = 'default_investment_filters';
export const DEFAULT_INITIATIVE_FILTERS = 'default_initiative_filters';
export const AG_GRID_ASSET_FILTERS = 'ag_grid_asset_filters';
export const DEFAULT_ASSET_FILTERS = 'default_asset_filters';
export const AG_GRID_INITIATIVE_FILTERS = 'ag_grid_initiative_filters';
export const AG_GRID_PROJECT_FILTERS = 'ag_grid_project_filters';
export const AG_GRID_WORKFLOW_HISTORY_FILTERS = 'ag_grid_workflow_history_filters';
export const LAST_ROUTE_INFO = 'last_route_info';
export const FILTER_KEY_PREFIX = 'filter__';
export const ASSET_FILTER_KEY_PREFIX = 'asset_filter__';
export const INITIATIVE_FILTER_KEY_PREFIX = 'initiative_filter__';
export const PROJECT_FILTER_KEY_PREFIX = 'project_filter__';
export const INVEST_FILTER_KEY_PREFIX = 'invest_filter__';
export const NOT_EMPTY_KEY_PREFIX = 'not_empty__';
export const RANGE_SEPARATOR = '-';
export const INSIGHT_GLOBAL_FILTER_STORAGE_KEY = 'insight-global-filters';
export const INSIGHT_ASSETS_FILTER_STORAGE_KEY = 'insight-assets-filters';
export const INVESTMENTS_STATUS = "investments-status"
export const BUDGET_OR_RATIO_FILTER_STORAGE_KEY = 'budget-or-ratio-filters';
export const BUDGET_OR_RATIO_CARBON_FILTER_STORAGE_KEY = 'budget-or-ratio-carbon-filters';
export const FORECAST_EMISSION_FACTOR_FILTER_STORAGE_KEY = 'forecast-emission-factor-filters';
export const PLANNED_INITIATIVE_FILTER_STORAGE_KEY = 'planned-initiative-filters';
export const INITIATIVE_PRIORITIES_FILTER_STORAGE_KEY = 'initiative-priorities-filters';
export const INITIATIVE_PRIORITIES_BY_TYPE_FILTER_STORAGE_KEY = 'initiative-priorities-by-type-filters';
export const INITIATIVE_SORTING_PRIORITY_FILTER_STORAGE_KEY = 'initiative-sorting-priority-filters';
export const FEASIBILITY_CONSUMPTION_OR_EMISSION_FILTER_STORAGE_KEY = 'feasibility-consumption-or-emission-filters'
export const INFLATION_HYPOTHESIS_STORAGE_KEY = 'inflation-hypothesis';
export const YEARLY_SAVINGS_FILTER_STORAGE_KEY = 'yearly-savings-filter';
export const KWH_SAVINGS_FILTER_STORAGE_KEY = 'kwh-gains-filter';
export const CEE_GAINS_FILTER_STORAGE_KEY = 'cee-gains-filter';
export const COUNT_LINKED_INITIATIVES_FILTER_STORAGE_KEY = 'count-linked-initiatives-filter';
export const ENERGY_REPORT_SECTION_STORAGE_KEY = 'energy-report-section';
export const START_YEAR_STORAGE_KEY = 'start-year';
export const END_YEAR_STORAGE_KEY = 'end-year';
export const SELECTED_PERIMETERS = 'selected-perimeters';
export const PREVIOUS_PERIMETERS = 'previous-perimeter';
export const ENERGY_COMPARISON_SETTINGS_MENU_STORAGE_KEY = 'energy-comparison-settings-menu';
export const DECISION_SETTINGS_MENU_STORAGE_KEY = 'decision-settings-menu';
export const SCENARII_INVEST_PLAN_SETTINGS_MENU_STORAGE_KEY = 'scenarii-invest-plan-settings-menu';
export const ENERGY_SETTINGS_MENU_STORAGE_KEY = 'energy-settings-menu';
export const ENERGY_MEASUREMENTS_KEY = 'energy-measurements-filters';
export const CONSUMPTION_AGGREGATION_KEY = 'consumption-filters';
export const ENERGY_CONSUMPTION_DATA_KEY = 'energy-consumption-data-filters';
export const ENERGY_CONSUMPTION_DISPLAY_KEY = 'energy-consumption-display-filters';
export const ENERGY_CONSUMPTION_BASELINEDEVIATION_KEY = 'energy-consumption-baseline-deviation-filters';
export const EMISSION_AGGREGATION_KEY = 'emission-aggregation-filter';
export const ENERGY_EMISSION_DATA_KEY = 'energy-emission-data-filters';
export const ENERGY_EMISSION_DISPLAY_KEY = 'energy-emission-display-filters';
export const ENERGY_EMISSION_BASELINEDEVIATION_KEY = 'energy-emission-baseline-deviation-filters';
export const DECISION_OVERVIEW_FILTER_STORAGE_KEY = 'decision-overview-filter';
export const ASSETS_SIMPLE_VIEW_PROJECTION_KEY = 'assets-simple-view-projection';
export const ENERGY_OR_CARBON_TRAJECTORY_KEY = 'energy-or-carbon-trajectory';
export const EMISSION_FACTOR_PROVIDER_FOR_ENERGY_KEY = 'emission-factor-provider-for-energy';
export const EMISSION_FACTOR_PROVIDER_FOR_CARBON_KEY = 'emission-factor-provider-for-carbon';
export const TYPE_OF_USE_BY_PROVIDER_ENERGY_STORAGE_KEY = 'type-of-use-by-provider-energy';
export const TYPE_OF_USE_BY_PROVIDER_CARBON_STORAGE_KEY = 'type-of-use-by-provider-carbon';
export const PPA_HYPOTHESIS_CHART = 'ppa-hypothesis-chart';
export const INVESTMENTS_CHART_HIDDEN_STATUSES_KEY = 'investments-columnchart-hidden-statuses';
export const MAX_PAYBACK_YEARS_STORAGE_KEY = 'max-payback-years';
export const ENERGY_CONSUMPTION_TYPE_STORAGE_KEY = 'energy-consumption-type';
export const CARBON_CONSUMPTION_TYPE_STORAGE_KEY = 'carbon-consumption-type';
export const THEORETICAL_OR_AUDIT_FILTER_STORAGE_KEY = 'theoretical-or-audit-filter';
export const PERIMETER_FILTER_SELECTION_STORAGE_KEY = 'perimeter-filter-selection';
export const PPA_OPTION_STORAGE_KEY = 'selected-PPA-Option';
export const LEVELS_MAP = {
  1: 0,
  2: 6,
  3: 14,
  4: 22,
  5: 30,
  6: 38,
  7: 46,
  8: 54,
  9: 62,
  10: 70,
  11: 78,
  12: 86,
  13: 94,
  14: 100,
};

export const STATE_LIMITS: number[] = [0, 22, 46, 70, 94, 100];
export const STATE_LABELS: string[] = ["Dead", "Critical", "Bad", "Acceptable", "Good", "New"];
// SITES TABLE
export const AG_GRID_SITES_FILTERS = 'ag_grid_sites_filters';
export const AG_GRID_SITES_SORTS = 'ag_grid_sites_sorts';
export const AG_GRID_SITES_COLUMNS = 'ag_grid_sites_columns';
export const AG_GRID_SITES_MOVED_COLUMNS = 'ag_grid_sites_moved_columns';
export const SITES_FILTER_KEY_PREFIX = 'sites_filter__';
export const PRICESHEETS_FILTER_KEY_PREFIX = 'pricesheets_filter__';
export const DEFAULT_SITES_FILTERS = 'default_sites_filters';
export const SELECTED_PLAN_ID = 'selected-plan-id';
export const TABLE_FILTER_ICON = '<i class="far fa-magnifying-glass"/>';

// AG GRID COLUMN STATES
export const AG_GRID_INVESTMENT_STATE = 'ag_grid_investment_state';
export const AG_GRID_ASSET_STATE = 'ag_grid_asset_state';
export const AG_GRID_INITIATIVE_STATE = 'ag_grid_initiative_state';
export const AG_GRID_SITES_STATE = 'ag_grid_sites_state';

// GAMMES
export const GAMME_PERIODICITY_LABELS: Record<string, string> = {
  '6_MONTHS': '1 × 6 months',
  '1_YEAR': '1 × year',
  '3_YEARS': '1 × 3 years',
  '5_YEARS': '1 × 5 years',
  '10_YEARS': '1 × 10 years',
  'PERMANENT': 'Permanent',
  '': '—',
};
